import { gql } from '@apollo/client';

export const GET_PROGRAM_TOPICS = gql`
  query getProgramTopicsList($programId: ID!) {
    programs(
      where: {
        id: $programId
        program_topics: { topic: { active: true, pages: { active: true } } }
      }
    ) {
      id
      titleKey: title_key
      description
      programTopics: program_topics {
        topic {
          id
          titleKey: title_key
          pages {
            id
            title
          }
        }
      }
    }
  }
`;
